import React from "react";
import Image1 from "../assets/img/images/animaker1.jpg";
import Image2 from "../assets/img/images/animaker2.jpg";
import Image3 from "../assets/img/images/animaker3.jpg";
 
const Animaker = () => {
  const isMobile = window.innerWidth <= 768;
 
  const sectionStyle = {
    display: "flex",
    alignItems: "center",
    gap: "30px",
    margin: "40px auto",
    flexWrap: "wrap",
    maxWidth: "80%",  // Set the max width to 80%

    flexDirection: isMobile ? "column" : "row",
  };
 
  const reverseStyle = {
    flexDirection: isMobile ? "column" : "row-reverse",
  };
 
  const imageStyle = {
    width: isMobile ? "100%" : "45%",
    minWidth: "280px",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  };
 
  const textStyle = {
    width: isMobile ? "100%" : "50%",
    minWidth: "280px",
  };
 
  return (
    <div
      style={{
        padding: "30px",
        fontFamily: "Poppins, sans-serif",
        margin: "6rem auto",
        minHeight: "100vh",
        backgroundColor: "#f9fafb",
        marginLeft: "auto",  // Center the content horizontally
        marginRight: "auto", // Center the content horizontally
      }}
    >
      <h1 style={{ textAlign: "center", color: "#7620ff", marginBottom: "30px" }}>
        Animaker: Create Stunning Animations and Videos
      </h1>
 
      {/* Intro */}
      <div style={sectionStyle}>
        <img src={Image1} alt="Animaker UI" style={imageStyle} />
        <div style={textStyle}>
          <p style={{ lineHeight: "1.8", color: "#333" }}>
            Animaker is a cloud-based online platform that enables users to create animated and live-action videos. It offers a user-friendly drag-and-drop interface, making it accessible to individuals of all skill levels. It also incorporates AI-powered features like text-to-video generation and voiceover capabilities.
          </p>
        </div>
      </div>
 
      {/* Features */}
      <div style={{ ...sectionStyle, ...reverseStyle }}>
        <img src={Image2} alt="Animaker Templates" style={imageStyle} />
        <div style={textStyle}>
          <h2 style={{ color: "#fdba00" }}>Key Features:</h2>
          <ul style={{ color: "#444", lineHeight: "1.8", paddingLeft: "20px" }}>
            <li><strong >User-friendly Interface:</strong> Drag-and-drop tools for easy creation.</li>
            <li><strong>AI-powered Tools:</strong> Includes text-to-video, voiceovers, and more.</li>
            <li><strong >Pre-designed Assets:</strong> Templates, characters, backgrounds, and more.</li>
            <li><strong >Customization:</strong> Easily personalize characters, animations, and text.</li>
            <li><strong >Collaboration:</strong> Team up on projects with shared access.</li>
            <li><strong >Hosting & Sharing:</strong> Publish videos to social platforms easily.</li>
          </ul>
        </div>
      </div>
 
      {/* Audience */}
      <div style={sectionStyle}>
        <img src={Image3} alt="Animaker Collaboration" style={imageStyle} />
        <div style={textStyle}>
          <h2 style={{ color: "#fdba00" }}>Target Audience:</h2>
          <ul style={{ color: "#444", lineHeight: "1.8", paddingLeft: "20px" }}>
            <li><strong >Beginners:</strong> Easy interface and tutorials for newcomers.</li>
            <li><strong >Businesses:</strong> Great for marketing videos and explainers.</li>
            <li><strong >Educators:</strong> Create engaging educational content.</li>
            <li><strong >Creators:</strong> Express ideas and tell stories visually.</li>
          </ul>
        </div>
      </div>
 
      {/* Outro */}
      <div style={{ marginTop: "40px" ,        maxWidth: "80%",margin:"30px auto"
 }}>
        <p style={{ lineHeight: "1.8", color: "#333", marginBottom: "16px",  }}>
          Whether you're a marketer, educator, entrepreneur, or hobbyist, Animaker helps turn your ideas into professional videos.
        </p>
        <p style={{ lineHeight: "1.8", color: "#333", marginBottom: "16px" }}>
          Cloud-based access allows you to work on projects from anywhere, and collaborate with others effortlessly.
        </p>
        <p style={{ lineHeight: "1.8", color: "#333",   }}>
          Start creating today with Animaker and bring your ideas to life!
        </p>
      </div>
    </div>
  );
};
 
export default Animaker;
 
 